import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'categories';

export default {
  state: {
    all: [],
    current: null
  },

  mutations: {
    setAllCategories(state, categories) {
      state.all = categories;
    },

    setCurrentCategory(state, category) {
      state.current = category;
    },

    addCategory(state, category) {
      if (category.fallback) {
        state.all = _.map(state.all, (c) => {
          c.fallback = false;
          return c;
        });
      }

      state.all.push(category);
    },

    updateCategory(state, category) {
      state.all = _.map(state.all, (c) => {
        if (c.id !== category.id) {
          if (category.fallback) c.fallback = false;
          return c;
        }
        return category;
      });
    }
  },

  actions: {
    fetchCategories({ commit }) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params: { team_id: auth.teamId() } })
        .then((resp) => {
          commit(
            "setAllCategories",
            _.map(resp.data.data, (cat) => cat.attributes)
          );
        })
        .catch((err) => console.error("Failed to fetch categories", err));
    },

    changeCurrentCategory({ commit, state }, categoryId) {
      const category = _.findWhere(state.all, { id: parseInt(categoryId) });
      commit("setCurrentCategory", category);

      return category;
    },

    createCategory({ commit }, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .post(`${apiVersion}/${source}`, params)
        .then((resp) => {
          commit("addCategory", resp.data.data.attributes);
        });
    },

    updateCategory({ commit }, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}`, params)
        .then((resp) => {
          commit("updateCategory", resp.data.data.attributes);
        })
        .catch((err) => console.error("Failed to update category", err));
    }
  },

  getters: {
    organisedCategories(state) {
      return _.reduce(
        state.all,
        (memo, category, index, list) => {
          if (category.parent_id) {
            const parent = _.findWhere(list, { id: category.parent_id });
            parent.children = parent.children || [];
            if (!_.contains(_.pluck(parent.children, "id"), category.id)) {
              parent.children.push(category);
            }
          } else {
            memo.push(category);
          }

          return memo;
        },
        []
      );
    }
  }
};
